import { render, staticRenderFns } from "./Ticket.vue?vue&type=template&id=b8b3221e&scoped=true&"
import script from "./Ticket.vue?vue&type=script&lang=js&"
export * from "./Ticket.vue?vue&type=script&lang=js&"
import style0 from "./Ticket.vue?vue&type=style&index=0&id=b8b3221e&prod&lang=css&"
import style1 from "./Ticket.vue?vue&type=style&index=1&id=b8b3221e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8b3221e",
  null
  
)

export default component.exports